import InvoicePlan from "models/invoicePlan";
import {formatLocale} from "./utils";

/**
 * An Organization
 * @param {string} name - Name
 * @param {string} weez_orga_id - Weezevent ID
 * @returns {Class} - Organization instance
 */
class Organization {
	constructor({
		name,
		weez_orga_id: weezID,
		medias,
		created,
		synchronized_at: synchronizedAt,
		synchronised_at: oldSynchronizedAt,
		invoice_plan: invoicePlan,
		cgu,
		activated,
		clear_task: clearTask,
		default_locale: defaultLocale,
	} = {}) {
		this._name = name;
		this._weezID = weezID;
		this._medias = medias || [];
		this._created = created;
		// Compatibility layer during the migration
		// in the API synchronised_at is renammed as synchronized_at in order
		// to respect conventions. When boby migrates this trick can be removed
		this._synchronizedAt = synchronizedAt || oldSynchronizedAt || null;
		this._invoicePlan = invoicePlan || null;
		this._cgu = cgu;
		this._activated = activated;
		this._clearTask = clearTask;
		this._default_locale = formatLocale(defaultLocale);
		;
	}

	toString() {
		return `O${this._weezID}`;
	}

	getKey() {
		return String(this._weezID);
	}

	getName() {
		return this._name;
	}

	getWeezID() {
		return this._weezID;
	}

	hasMail() {
		return Boolean(this._medias.includes("mail"));
	}

	hasGreencopper() {
		return Boolean(this._medias.includes("greencopper"));
	}

	isSynchronized() {
		return Boolean(this._synchronizedAt);
	}

	getCurrentPlan() {
		return this._invoicePlan ? new InvoicePlan(this._invoicePlan) : null;
	}

	getCurrency() {
		return 'EUR';
	}

	getCreatedDate() {
		return this._created;
	}

	cguAccepted() {
		return this._cgu !== null;
	}

	isActivated() {
		return this._activated !== null;
	}

	getActivatedDate() {
		const date = new Date(this._activated);
		const formatted = new Intl.DateTimeFormat(undefined, {
			year: "numeric",
			month: "short",
			day: "numeric",
		}).format(date);
		return formatted ;
	}

	getClearTask() {
		return this._clearTask;
	}

	getDefaultLocale() {
		return this._default_locale;
	}
}
export default Organization;
